import router from '@/router/index.ts'
import { NavigationGuardNext, RouteLocationNormalizedGeneric } from 'vue-router'
import { useGlobalLoading } from '@/hooks/useGlobalLoading.ts'
import { useSessionStorage } from '@/hooks/web/useStorage.ts'
import { setSignCode } from '@/utils/CryptoJS.ts'
import { initWxConfig } from '@/utils/wxTool.ts'
import { isWxBrowser } from '@/utils/is.ts'

const sessionStorage = useSessionStorage()
const { openGlobalLoading, closeGlobalLoading } = useGlobalLoading()

// 需要加载全局loading的路由
const OPEN_LOADING_ROUTE = ['Mobile', 'commodity']

/**
 * 环境配置前置处理
 * 1. 全局loading
 * 2. 加密参数处理
 * 3. 初始化微信js sdk
 */
router.beforeEach(
  async (to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric, next: NavigationGuardNext) => {
    console.log(`env-before -----> from name: ${from.name as string}`)
    // 如果是以下页面，则打开全局loading
    const routeName = to.name as string
    if (OPEN_LOADING_ROUTE.includes(routeName) && from.path !== to.path) {
      openGlobalLoading(true)
    } else {
      closeGlobalLoading()
    }

    if (to.name === 'NoFind') {
      return next()
    }

    const paramsId = to.params.id
    if (!paramsId) {
      return next()
    }

    // 加密参数解析处理
    const decryptInfo = await setSignCode(paramsId as string)
    console.log('参数11', decryptInfo)
    if (Object.keys(decryptInfo).length === 0) {
      return next('/nopremission/9')
    }

    // 直播没有roomId 或者 clientId
    if (['Mobile', 'Live'].includes(to.name as string)) {
      if (!decryptInfo.roomId || !decryptInfo.clientId) {
        return next('/nopremission/9')
      }
    }

    // 栏目没有clientId
    if (['column'].includes(to.name as string)) {
      if (!decryptInfo.clientId) {
        return next('/nopremission/9')
      }
    }
    Object.entries(decryptInfo).forEach(([key, value]) => {
      if (key === 'accountId' && value) {
        // 渠道改动，链接渠道ID作为商品
        sessionStorage.set('originalAccountId', value)
      }
      sessionStorage.set(key, value)
    })
    // 清除渠道名称
    sessionStorage.set('channelName', '')
    // sessionStorage.set('encrypt', paramsId)
    // 加密参数正确并且是微信浏览器，初始化微信js sdk
    if (['Mobile', 'Live'].includes(to.name as string) && isWxBrowser()) {
      await initWxConfig(sessionStorage.get('encrypt') as string)
    }
    next()
  }
)

/**
 * 加密参数处理
 * @param to
 */
// const decryptParamsHandler = (to: RouteLocationNormalizedGeneric) => {
//   const paramsId = to.params.id
//   if (!paramsId) {
//     return false
//   }
//   const decryptInfo = setSignCode(paramsId as string)
//
//   Object.entries(decryptInfo).forEach(([key, value]) => {
//     sessionStorage.set(key, value)
//   })
//
// const clientId = decryptInfo.clientId || ''
// const roomId = decryptInfo.roomId || ''
// const accountId = decryptInfo.accountId || ''
// const originalAccountId = accountId
// const columnId = decryptInfo.columnId || ''
//
// sessionStorage.set('clientId', clientId)
// sessionStorage.set('roomId', roomId)
// sessionStorage.set('originalAccountId', originalAccountId ?? '')
// sessionStorage.set('accountId', accountId ?? '')
// sessionStorage.set('columnId', columnId ?? '')
// sessionStorage.set('encrypt', paramsId)
// sessionStorage.set('userId', getLoginInfo('userId') || '')
// }
